import { render, staticRenderFns } from "./Peers.vue?vue&type=template&id=a834147c&scoped=true&"
import script from "./Peers.vue?vue&type=script&lang=ts&"
export * from "./Peers.vue?vue&type=script&lang=ts&"
import style0 from "./Peers.vue?vue&type=style&index=0&id=a834147c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a834147c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
